<template>
  <div class="stages-list">
    <div
      v-for="stage in stageList"
      :key="stage.stage_id"
      :class="['stage', { 'is-not-active': !stage.is_active }]"
    >
      <p class="header">{{ stage.stage_name | format }}</p>
      <div class="tags">
        <div
          v-if="stage.coordination_term"
          :class="['tag', { 'is-expired': stage.is_expired }]"
        >
          {{ stage.coordination_term }}
        </div>
        <div class="tag">{{ setTagOperator(stage.operator) }}</div>
      </div>
      <div v-if="stage.coordinators.length" class="coordinator-list">
        <div
          class="coordinator"
          v-for="coordinator in stage.coordinators"
          :key="coordinator.id"
        >
          <span
            :class="{ strikethrough: coordinator.status == 'redirected' }"
            >{{ coordinator.user_name }}</span
          >
          <Tooltip
            popper-class="dark"
            placement="top-start"
            :content="getStatus(coordinator.status).tooltip"
            class="coordinator__icon"
          >
            <Icon :iconName="getStatus(coordinator.status).icon" />
          </Tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'Elements/Icon/Icon';
import Tooltip from 'Elements/Tooltip/Tooltip';

export default {
  props: {
    stageList: Array
  },
  methods: {
    setTagOperator(operator) {
      if (operator == 'AND') return 'Каждый из этапа';
      else if (operator == 'OR') return 'Любой из этапа';
      else return '';
    },
    getStatus(status) {
      switch (status) {
        case 'pending_approvement':
          return { tooltip: 'Ожидается согласование', icon: 'hourglass' };
        case 'approved':
          return { tooltip: 'Согласовано', icon: 'agreed' };
        case 'declined':
          return { tooltip: 'Отклонено', icon: 'rejected' };
        case 'need_refactoring':
          return { tooltip: 'Отправлено на доработку', icon: 'reply-all' };
        case 'redirected':
          return { tooltip: 'Перенаправлено', icon: 'users-orange' };

        default:
          return { tooltip: '', icon: '' };
      }
    }
  },
  components: {
    Icon,
    Tooltip
  }
};
</script>

<style lang="scss" scoped>
.stages-list {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
  max-height: calc(100vh - 78px);
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
.stage.is-not-active {
  border: 1px solid $grey8;
}
.stage {
  background: $white;
  border: 1px solid $grey16;
  border-radius: 4px;
  padding: 16px;
}
.header {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: left;
}
.tags {
  display: flex;
  margin-top: 4px;
  gap: 8px;
}
.tag {
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  color: $grey40;
  padding: 0 6px;
  background: $grey12;
  border: 1px solid transparent;
  border-radius: 4px;
}
.is-expired {
  color: $red;
  background: $red16;
}
.coordinator {
  display: flex;
  justify-content: space-between;

  span {
    max-width: 224px;
    color: $grey64;
    line-height: 24px;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon {
    margin-left: 8px;
  }
}
.coordinator-list {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 8px;
}
.strikethrough {
  text-decoration: line-through;
}
.is-not-active {
  .coordinator-list span,
  .header {
    color: $grey40;
  }
}
</style>
